export const STANDARD_DATE_FORMAT = 'dd/MM/yyyy';
export const DATE_MONTH_FORMAT = 'dd/MMM';
